import { render, staticRenderFns } from "./AssessmentExampleEndButton.vue?vue&type=template&id=3ed04405&"
import script from "./AssessmentExampleEndButton.vue?vue&type=script&lang=js&"
export * from "./AssessmentExampleEndButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports